import PlacesWorkerForCreateModel from "./PlacesWorkerForCreationModel";

export default class PlacesWorkerForUpdateModel extends PlacesWorkerForCreateModel {
    id: number;

    constructor(obj?: PlacesWorkerForUpdateModel) {
        super(obj);
        this.id = obj?.id;
    }
}